import { Component, OnInit } from '@angular/core';
import { Discipline } from 'src/app/models/discipline.model';
import { DisciplineService } from 'src/app/services/discipline.service';

@Component({
  selector: 'app-disciplines',
  templateUrl: './disciplines.component.html',
  styleUrls: ['./disciplines.component.sass']
})
export class DisciplinesComponent implements OnInit {

  disciplines: Discipline[] = [];

  constructor(private disciplineService:DisciplineService) { }

  ngOnInit(): void {
    this.disciplineService.getVisibleDisciplines().subscribe(data => {
      data.data.forEach((element: any) => {
          let d = this.disciplineService.populateDiscipline(element);
          this.disciplines.push(d);
      });
    });
  }

}
